import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Account from '../../../shared/model/account/Account';
import { filterByProp } from '../../../shared/util/collection';
import TitleComponent from './Title';

const People = ({ people, ids }) => {
  const peopleFiltered = useMemo(() => filterByProp(people, ids, 'id', 'name'), [people, ids]);
  if (!peopleFiltered) {
    return null;
  }
  return map(peopleFiltered, (person) => (
    <TitleComponent
      key={person.id}
      avatar={person.getAvatar()}
      title={person.getName()}
      trivial
    />
  ));
};

People.propTypes = {
  people: PropTypes.arrayOf(PropTypes.instanceOf(Account)).isRequired,
  ids: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
};

People.defaultProps = {
  ids: null
};

export default People;
